// removed by extract-text-webpack-plugin
module.exports = {"vpCheckboxElementContainer":"vpCheckboxElementContainer___GT6Fv","vpCheckboxElementContainerHiddenCheck":"vpCheckboxElementContainerHiddenCheck___2lAqz","vpCheckboxRichText":"vpCheckboxRichText___yKn9q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CheckboxElement.module.less
// module id = 2883
// module chunks = 29